import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {PreCleaningModel} from "../core/models/PreCleaningModel";
import {SiteModel} from "../core/models/SiteModel";

@Injectable()
export class CommissioningService {

  preCleaning= new PreCleaningModel(new SiteModel());

  ticketInformation = {
    personalInformation: {
      firstname: '',
      lastname: '',
      age: null
    },
    seatInformation: {
      class: null,
      wagon: null,
      seat: null
    },
    paymentInformation: {
      cardholderName: '',
      cardholderNumber: '',
      date: '',
      cvv: '',
      remember: false
    }
  };

  private paymentComplete = new Subject<any>();

  paymentComplete$ = this.paymentComplete.asObservable();


  getPreCleaning() {
    return this.preCleaning;
  }

  getTicketInformation() {
    return this.ticketInformation;
  }

  // @ts-ignore
  setTicketInformation(ticketInformation) {
    this.ticketInformation = ticketInformation;
  }

  complete() {
    this.paymentComplete.next(this.ticketInformation.personalInformation);
  }
}

